<ion-header>
  <ion-toolbar>
    <ion-title class="toolbar">
      {{ type == "refuser" ? "Refuser" : "Reporter" }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid fixed>
    @if (type != 'refuser') {
    <ion-item>
      <ion-label floating
        >Date de {{ type == "refuser" ? "refus" : "report" }}*
      </ion-label>
      <ion-datetime-button datetime="datetime" slot="end"></ion-datetime-button>
      <ion-popover [keepContentsMounted]="true">
        <ng-template>
          <ion-datetime
            [(ngModel)]="selectedDate"
            [max]="maxDate"
            [min]="minDate"
            cancel-text="Annuler"
            done-text="Reporter"
            firstDayOfWeek="1"
            id="datetime"
            locale="fr-FR"
            presentation="date"
            show-default-buttons="true">
          </ion-datetime>
        </ng-template>
      </ion-popover>
    </ion-item>
    } @if (mission && listeMotifs.length > 0) {
    <ion-item>
      <ion-select
        [(ngModel)]="detail.motif"
        cancelText="Annuler"
        fill="outline"
        label="Motif*"
        label-placement="floating"
        okText="Valider"
        style="width: 100vw !important">
        @for (motif of listeMotifs; track motif.Value) {
        <ion-select-option [disabled]="motif.Disabled" [value]="motif.Value"
          >{{ motif.Text }}
        </ion-select-option>
        }
      </ion-select>
    </ion-item>
    }
    <ion-item>
      <ion-textarea
        [(ngModel)]="detail.commentaire"
        label="Commentaire"
        label-placement="floating">
      </ion-textarea>
    </ion-item>
    @if (type == 'refuser') {
    <ion-item>
      <ion-textarea
        [(ngModel)]="detail.responsable"
        label="Nom du contact ayant refusé*"
        label-placement="floating">
      </ion-textarea>
    </ion-item>
    }
    <ion-row>
      <ion-col size="6">
        <ion-button (click)="dismiss()" color="dark" expand="block"
          >Annuler
        </ion-button>
      </ion-col>
      <ion-col size="6">
        <ion-button
          (click)="closeModal()"
          [disabled]="
            (type == 'reporter' &&
              !(detail.date && detail.motif && detail.motif.length > 0)) ||
            (type == 'refuser' &&
              !(
                detail.motif &&
                detail.motif.length > 0 &&
                detail.responsable &&
                detail.responsable.length > 0
              ))
          "
          class="custom"
          expand="block"
          >Valider
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
